import * as app from './js/modules/app.js'

if(window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') 
{
    location.replace(`https:${location.href.substring(location.protocol.length)}`)
} else {
    app.initialize()
}

// app.initialize()